/**
 * Photo upload limits
 *
 * IMPORTANT: This value MUST match the backend constant in
 * exhale-server/src/config/constants.ts to ensure frontend and
 * backend validation remain in sync.
 *
 * If you change this value, you MUST also update the backend constant.
 */

/**
 * Maximum number of photos that can be uploaded per request
 * This limit is enforced by:
 * - Backend: Multer middleware configuration (exhale-server/src/config/upload.config.ts)
 * - Frontend: Photo capture component validation (PhotoCapture.web.tsx and PhotoCapture.native.tsx)
 */
export const MAX_PHOTOS_PER_UPLOAD = 100;
